import Talk from 'talkjs'
import { Apartment } from '../types/apartments'
import { Application } from '../types/applications'
import { Deferred } from './deferred'
import { API } from 'aws-amplify'
import { CHAT_SCHEDULING_KEYWORDS_LIST } from './talkChatMessageKeywords'

let loadedPopups: Talk.Popup[] = []
const sessionDeferred = new Deferred<Talk.Session>()

export interface TalkUser {
  id: string
  name: string
  email?: string
  phone?: string
  role?: string
}

export async function createTalkUser(user: TalkUser): Promise<Talk.User> {
  await Talk.ready

  return new Talk.User({
    id: user.id,
    name: user.name,
    email: user.email,
    role: user.role || 'applicant',
    phone: user.phone
  })
}

export async function getConversationById(conversationId: string) {
  const session = await get()

  if (!conversationId || conversationId === '') {
    console.log('Chat session unavailable')
    return false
  }

  const conversationBuilder = session.getOrCreateConversation(conversationId)
  return conversationBuilder
}

// session: Talk.Session,
// currentUserId: string,
// currentUserName: string,
export async function getOrCreateConversation(
  apartment: Apartment,
  application: Application
) {
  const session = await get()
  const conversationBuilder = session.getOrCreateConversation(
    application ? application.applicationId : apartment.apartmentId
  )
  return conversationBuilder
}

export const reportSpecificKeywordUsageTalkJs = async (event: any) => {

  try {
    console.log('Message sent:', event);

    if (!event?.conversation?.id) return;

    const message = event.message.text

    /// if message contains any keyword
    const keywordExist = CHAT_SCHEDULING_KEYWORDS_LIST.some((keyword) => message.includes(keyword));

    if (keywordExist) {

      await API.post(
        'applications',
        '/talkjs/report-keyword-usage',
        {
          body: {
            conversationId: event.conversation.id
          }
        }
      )
    }

  } catch (error) {
    console.error('Error reporting keyword usage:', error)
  }
};

export function addPopup(popup: Talk.Popup) {
  destroyAllPopups()
  popup.onSendMessage((event: any) => {
    reportSpecificKeywordUsageTalkJs(event);
  })
  loadedPopups.push(popup)
}

export function destroyAllPopups() {
  if (loadedPopups.length > 0) {
    loadedPopups.forEach((p) => p.destroy())
    loadedPopups = []
  }
}

export async function initialize(user: TalkUser) {
  if (window.talkInitialized) {
    return Promise.resolve('Session active')
  }

  await Talk.ready

  await sessionDeferred.resolve(
    new Talk.Session({
      appId: process.env.REACT_APP_TALKJS_APP_ID || '',
      me: await createTalkUser(user)
    })
  )

  window.talkSession = await get()
  window.talkInitialized = true
}

export function get(): Promise<Talk.Session> {
  return sessionDeferred.promise
}
